const ITEMS = [
  "Pertenencia",
  "Conversación",
  "Calma",
  "Conexión",
  "Autenticidad",
  "Curiosidad",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[#22304D] bg-[#0B1120] py-6"
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max items-center">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={`${item}-${Math.floor(i / ITEMS.length)}`} className="flex items-center">
          <span className="px-8 font-[Fraunces] text-2xl font-semibold tracking-[0.08em] text-[#2A3A5C] md:text-3xl">
            {item}
          </span>
          <span className="h-2 w-2 shrink-0 rounded-full bg-[#8B7CF6]/40" />
        </span>
      ))}
    </div>
  </div>
);
